import { Input, Output, EventEmitter, ChangeDetectorRef, OnInit } from '@angular/core';
import { WorkFieldInputChangeEvent } from '../../../events/work-field-input-change-event';
import { FormControl, Validators } from '@angular/forms';
import { E5coreUiWorkFieldTypeComponentBase } from '../../../components/e5core-ui-work-field/e5core-ui-work-field-type-component-base';
import {CurrencyPipe} from '@angular/common'

export class E5coreUiWorkFieldTypeCurrencyBaseComponent extends E5coreUiWorkFieldTypeComponentBase implements OnInit {

  @Input() pattern: string ; // Regex
  @Output() valueChange = new EventEmitter<WorkFieldInputChangeEvent>() ;

  formControl: FormControl ;
  currencyValue: number ;

  constructor(private cp: CurrencyPipe) {
    super() ;
  }

  ngOnInit() {
    const validators = [] ;
    if (this.field && this.field.isRequired) {
      validators.push(Validators.required) ;
    }
    var formatted = this.cp.transform(this.property.value, "USD", "", "1.2-2") ;
    this.formControl = new FormControl(formatted, validators);
    this.formControl.markAsTouched() ;
    const error = this.getError() ;
    this.updatePropertyValueOnChange(this.formControl) ;
  }

  protected getError(): string {
    let error = '' ;
    if (this.formControl.hasError('required')) {
      error = 'required' ;
    }
    return (error) ;
  }

  get resolvedPattern(): string {
    return (this.pattern || this.property.pattern) ;
  }

  changeValue($event: string) {
    this.valueChange.emit({$event: $event, value: $event, error: this.getError()}) ;
  }

  blur($event) {
    this.changeValue(this.formControl.value) ;
  }

  private formatToCurrency():String {
    return "" ;
  }

}
